import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { logger } from '../logger';
import { BaseMetric, MetricState } from './base-metric';
export class BasePageLoadMetric extends BaseMetric {
  constructor(args) {
    super(args);

    _defineProperty(this, "isInitial", true);

    _defineProperty(this, "explicitTimings", null);

    this.config = args;
  }

  start({
    startTime = window.performance.now()
  } = {}) {
    // please use startPageLoad
    return;
  }

  startPageLoad(params = {
    isInitial: false
  }) {
    // todo this should update meta page load metric
    this.isInitial = params.isInitial;

    if (params.isInitial) {
      super.start({
        startTime: 0
      });
    } else {
      super.start(params);
    }

    logger.logCond(!!this.config.debug, this.key, this.startTime);
  }

  stopPageLoad(pageLoadMetaMetricData, stopArguments = {
    stopTime: window.performance.now()
  }) {
    if (pageLoadMetaMetricData.state !== MetricState.STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
      logger.log(`meta metric has been stopped while not being started before; current state: ${this.state}`);
      return false;
    }

    if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
      logger.log(`metric ${this.config.key} has been stopped with stopTime lower than startTime; startTime: ${pageLoadMetaMetricData.start}; stopTime: ${stopArguments.stopTime}`);
      return false;
    }

    this.merge(pageLoadMetaMetricData);
    this.stopTime = stopArguments.stopTime;
    this.state = MetricState.FINISHED;
    this.handleStop(stopArguments);
    return true;
  }

  handleStop(stopArguments) {
    if (this.config.until) {
      const data = this.config.until.getData();

      if (!(BasePageLoadMetric.FMP in this.marks) && BasePageLoadMetric.FMP in data.marks) {
        this.markFMP(data.marks.fmp);
      }
    }

    super.handleStop(stopArguments);
  }

  mark(mark, timestamp = window.performance.now()) {
    if (mark === BasePageLoadMetric.FMP) {
      return;
    }

    super.mark(mark, timestamp);
  }

  merge(mergeData) {
    super.merge(mergeData);
    this.isInitial = mergeData.isInitial;
    this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? { ...mergeData.explicitTimings,
      ...this.explicitTimings
    } : null;
  }

  markFMP(timestamp) {
    super.mark(BasePageLoadMetric.FMP, timestamp);
  }

  getPageLoadData() {
    return {
      isInitial: this.isInitial,
      explicitTimings: this.explicitTimings
    };
  }

  getData() {
    return { ...super.getData(),
      ...this.getPageLoadData()
    };
  }

  getDataToMerge() {
    return { ...super.getDataToMerge(),
      ...this.getPageLoadData()
    };
  }

  clear() {
    this.explicitTimings = null;
    super.clear();
  }

}

_defineProperty(BasePageLoadMetric, "FMP", 'fmp');